<div class="container">
  <div class="row" *ngFor="let list of rows">
    <div class="app-shortcut-view col-md-6" *ngFor="let item of list">
      <a class="app-shortcut app-shortcut-icon" [ngClass]="item.className" [routerLink]="item.link">
        <p class="app-text h4">{{ item.localeText ? (item.localeText | localize) : item.text }}</p>
        <p class="app-overlay text-center">
          <span class="k-icon k-i-arrow-60-right"></span>
        </p>
      </a>
    </div>
  </div>
  <ng-container *ngIf="!isDevMode">
    <div class="metrika-informer">
      <!-- Yandex.Metrika informer -->
      <a href="https://metrika.yandex.ru/stat/?id=98459578&amp;from=informer" target="_blank" rel="nofollow"
        ><img
          src="https://informer.yandex.ru/informer/98459578/3_0_FFFFFFFF_EFEFEFFF_0_pageviews"
          style="width: 88px; height: 31px; border: 0"
          alt="Яндекс.Метрика"
          title="Яндекс.Метрика: данные за сегодня (просмотры, визиты и уникальные посетители)"
          class="ym-advanced-informer"
          data-cid="98459578"
          data-lang="ru"
      /></a>
      <!-- /Yandex.Metrika informer -->
    </div>
  </ng-container>
</div>
